export const PetalumaScriptFont = {
    spacing: 50,
    glyphs: {
        ' ': {
            xMin: 0,
            xMax: 250,
            yMin: 0,
            yMax: 500,
            ha: 500,
            leftSideBearing: 0,
            advanceWidth: 250,
        },
        '0': {
            xMin: 33,
            xMax: 534,
            yMin: -13,
            yMax: 751,
            ha: 764,
            leftSideBearing: 33,
            advanceWidth: 570,
        },
        '1': {
            xMin: 48,
            xMax: 235,
            yMin: -17,
            yMax: 734,
            ha: 751,
            leftSideBearing: 48,
            advanceWidth: 286,
        },
        '2': {
            xMin: 56,
            xMax: 571,
            yMin: -19,
            yMax: 741,
            ha: 760,
            leftSideBearing: 56,
            advanceWidth: 626,
        },
        '3': {
            xMin: 50,
            xMax: 528,
            yMin: -7,
            yMax: 731,
            ha: 738,
            leftSideBearing: 50,
            advanceWidth: 589,
        },
        '4': {
            xMin: 38,
            xMax: 564,
            yMin: -13,
            yMax: 743,
            ha: 756,
            leftSideBearing: 38,
            advanceWidth: 614,
        },
        '5': {
            xMin: 42,
            xMax: 601,
            yMin: -34,
            yMax: 743,
            ha: 777,
            leftSideBearing: 42,
            advanceWidth: 648,
        },
        '6': {
            xMin: 47,
            xMax: 606,
            yMin: -16,
            yMax: 743,
            ha: 759,
            leftSideBearing: 47,
            advanceWidth: 667,
        },
        '7': {
            xMin: 47,
            xMax: 567,
            yMin: 5,
            yMax: 739,
            ha: 734,
            leftSideBearing: 0,
            advanceWidth: 615,
        },
        '8': {
            xMin: 40,
            xMax: 541,
            yMin: -15,
            yMax: 752,
            ha: 767,
            leftSideBearing: 40,
            advanceWidth: 585,
        },
        '9': {
            xMin: 40,
            xMax: 537,
            yMin: -52,
            yMax: 736,
            ha: 788,
            leftSideBearing: 40,
            advanceWidth: 592,
        },
        '!': {
            xMin: 49,
            xMax: 180,
            yMin: -7,
            yMax: 761,
            ha: 768,
            leftSideBearing: 49,
            advanceWidth: 230,
        },
        '"': {
            xMin: 39,
            xMax: 304,
            yMin: 596,
            yMax: 804,
            ha: 208,
            leftSideBearing: 39,
            advanceWidth: 353,
        },
        '#': {
            xMin: 33,
            xMax: 599,
            yMin: -8,
            yMax: 765,
            ha: 773,
            leftSideBearing: 33,
            advanceWidth: 648,
        },
        $: {
            xMin: 53,
            xMax: 495,
            yMin: -111,
            yMax: 823,
            ha: 934,
            leftSideBearing: 53,
            advanceWidth: 560,
        },
        '%': {
            xMin: 35,
            xMax: 656,
            yMin: -128,
            yMax: 808,
            ha: 936,
            leftSideBearing: 35,
            advanceWidth: 711,
        },
        '&': {
            xMin: 53,
            xMax: 441,
            yMin: -3,
            yMax: 753,
            ha: 756,
            leftSideBearing: 53,
            advanceWidth: 500,
        },
        "'": {
            xMin: 43,
            xMax: 161,
            yMin: 590,
            yMax: 811,
            ha: 221,
            leftSideBearing: 43,
            advanceWidth: 217,
        },
        '(': {
            xMin: 41,
            xMax: 311,
            yMin: -36,
            yMax: 845,
            ha: 881,
            leftSideBearing: 41,
            advanceWidth: 308,
        },
        ')': {
            xMin: -8,
            xMax: 257,
            yMin: -21,
            yMax: 852,
            ha: 873,
            leftSideBearing: -8,
            advanceWidth: 280,
        },
        '*': {
            xMin: 59,
            xMax: 539,
            yMin: 175,
            yMax: 589,
            ha: 414,
            leftSideBearing: 59,
            advanceWidth: 601,
        },
        '+': {
            xMin: 33,
            xMax: 361,
            yMin: 180,
            yMax: 587,
            ha: 407,
            leftSideBearing: 33,
            advanceWidth: 400,
        },
        ',': {
            xMin: 15,
            xMax: 176,
            yMin: -129,
            yMax: 92,
            ha: 221,
            leftSideBearing: 15,
            advanceWidth: 205,
        },
        '-': {
            xMin: 40,
            xMax: 380,
            yMin: 317,
            yMax: 452,
            ha: 135,
            leftSideBearing: 40,
            advanceWidth: 422,
        },
        '.': {
            xMin: 48,
            xMax: 185,
            yMin: -56,
            yMax: 84,
            ha: 140,
            leftSideBearing: 48,
            advanceWidth: 227,
        },
        '/': {
            xMin: -58,
            xMax: 654,
            yMin: -122,
            yMax: 844,
            ha: 966,
            leftSideBearing: -58,
            advanceWidth: 626,
        },
        ':': {
            xMin: 65,
            xMax: 225,
            yMin: 97,
            yMax: 536,
            ha: 439,
            leftSideBearing: 65,
            advanceWidth: 302,
        },
        ';': {
            xMin: 13,
            xMax: 295,
            yMin: -139,
            yMax: 536,
            ha: 675,
            leftSideBearing: 13,
            advanceWidth: 334,
        },
        '<': {
            xMin: 28,
            xMax: 438,
            yMin: -1,
            yMax: 607,
            ha: 608,
            leftSideBearing: 28,
            advanceWidth: 475,
        },
        '=': {
            xMin: 40,
            xMax: 383,
            yMin: 199.9598640852289,
            yMax: 541,
            ha: 341.0401359147711,
            leftSideBearing: 40,
            advanceWidth: 422,
        },
        '>': {
            xMin: 35,
            xMax: 421,
            yMin: 28,
            yMax: 632,
            ha: 604,
            leftSideBearing: 35,
            advanceWidth: 466,
        },
        '?': {
            xMin: 45,
            xMax: 548,
            yMin: -17,
            yMax: 767,
            ha: 784,
            leftSideBearing: 45,
            advanceWidth: 592,
        },
        '@': {
            xMin: 51,
            xMax: 730,
            yMin: -78,
            yMax: 753,
            ha: 831,
            leftSideBearing: 51,
            advanceWidth: 781,
        },
        A: {
            xMin: 37,
            xMax: 554,
            yMin: -4,
            yMax: 746,
            ha: 750,
            leftSideBearing: 37,
            advanceWidth: 617,
        },
        B: {
            xMin: 37,
            xMax: 532,
            yMin: 3,
            yMax: 783,
            ha: 780,
            leftSideBearing: 37,
            advanceWidth: 579,
        },
        C: {
            xMin: 37,
            xMax: 583,
            yMin: -3,
            yMax: 775,
            ha: 778,
            leftSideBearing: 37,
            advanceWidth: 623,
        },
        D: {
            xMin: 50,
            xMax: 530,
            yMin: -15,
            yMax: 749,
            ha: 764,
            leftSideBearing: 50,
            advanceWidth: 579,
        },
        E: {
            xMin: 45,
            xMax: 531,
            yMin: -1,
            yMax: 743,
            ha: 744,
            leftSideBearing: 45,
            advanceWidth: 585,
        },
        F: {
            xMin: 45,
            xMax: 459,
            yMin: 23,
            yMax: 727,
            ha: 704,
            leftSideBearing: 45,
            advanceWidth: 510,
        },
        G: {
            xMin: 31,
            xMax: 577,
            yMin: -8,
            yMax: 733,
            ha: 741,
            leftSideBearing: 31,
            advanceWidth: 611,
        },
        H: {
            xMin: 37,
            xMax: 493,
            yMin: -22,
            yMax: 758,
            ha: 780,
            leftSideBearing: 37,
            advanceWidth: 535,
        },
        I: {
            xMin: 47,
            xMax: 501,
            yMin: -3,
            yMax: 731,
            ha: 734,
            leftSideBearing: 47,
            advanceWidth: 541,
        },
        J: {
            xMin: 33,
            xMax: 531,
            yMin: -23,
            yMax: 725,
            ha: 748,
            leftSideBearing: 33,
            advanceWidth: 573,
        },
        K: {
            xMin: 43,
            xMax: 505,
            yMin: -10,
            yMax: 740,
            ha: 750,
            leftSideBearing: 43,
            advanceWidth: 560,
        },
        L: {
            xMin: 49,
            xMax: 457,
            yMin: -2,
            yMax: 746,
            ha: 748,
            leftSideBearing: 49,
            advanceWidth: 510,
        },
        M: {
            xMin: 35,
            xMax: 699,
            yMin: 1,
            yMax: 744,
            ha: 743,
            leftSideBearing: 35,
            advanceWidth: 743,
        },
        N: {
            xMin: 34,
            xMax: 533,
            yMin: -17,
            yMax: 761,
            ha: 778,
            leftSideBearing: 34,
            advanceWidth: 579,
        },
        O: {
            xMin: 41,
            xMax: 608,
            yMin: -5,
            yMax: 735,
            ha: 740,
            leftSideBearing: 41,
            advanceWidth: 667,
        },
        P: {
            xMin: 53,
            xMax: 451,
            yMin: -18,
            yMax: 735,
            ha: 753,
            leftSideBearing: 53,
            advanceWidth: 497,
        },
        Q: {
            xMin: 40,
            xMax: 599,
            yMin: -67,
            yMax: 744,
            ha: 811,
            leftSideBearing: 40,
            advanceWidth: 648,
        },
        R: {
            xMin: 39,
            xMax: 487,
            yMin: 16,
            yMax: 735,
            ha: 719,
            leftSideBearing: 39,
            advanceWidth: 535,
        },
        S: {
            xMin: 35,
            xMax: 552,
            yMin: -47,
            yMax: 708,
            ha: 755,
            leftSideBearing: 35,
            advanceWidth: 604,
        },
        T: {
            xMin: 26,
            xMax: 656,
            yMin: -13,
            yMax: 718,
            ha: 731,
            leftSideBearing: 26,
            advanceWidth: 705,
        },
        U: {
            xMin: 41,
            xMax: 518,
            yMin: -20,
            yMax: 748,
            ha: 768,
            leftSideBearing: 41,
            advanceWidth: 567,
        },
        V: {
            xMin: 47,
            xMax: 509,
            yMin: -26,
            yMax: 744,
            ha: 770,
            leftSideBearing: 47,
            advanceWidth: 567,
        },
        W: {
            xMin: 44,
            xMax: 789,
            yMin: -35,
            yMax: 720,
            ha: 755,
            leftSideBearing: 44,
            advanceWidth: 833,
        },
        X: {
            xMin: 63,
            xMax: 635,
            yMin: -10,
            yMax: 745,
            ha: 755,
            leftSideBearing: 63,
            advanceWidth: 680,
        },
        Y: {
            xMin: 43,
            xMax: 503,
            yMin: -21,
            yMax: 734,
            ha: 755,
            leftSideBearing: 43,
            advanceWidth: 541,
        },
        Z: {
            xMin: 42,
            xMax: 584,
            yMin: -10,
            yMax: 739,
            ha: 749,
            leftSideBearing: 42,
            advanceWidth: 629,
        },
        '[': {
            xMin: 46,
            xMax: 346,
            yMin: -150,
            yMax: 884,
            ha: 1034,
            leftSideBearing: 46,
            advanceWidth: 291,
        },
        '\\': {
            xMin: 20,
            xMax: 616,
            yMin: -100,
            yMax: 797,
            ha: 897,
            leftSideBearing: 20,
            advanceWidth: 645,
        },
        ']': {
            xMin: -76,
            xMax: 226,
            yMin: -150,
            yMax: 881,
            ha: 1031,
            leftSideBearing: -76,
            advanceWidth: 297,
        },
        '^': {
            xMin: 43,
            xMax: 437,
            yMin: 517,
            yMax: 812,
            ha: 295,
            leftSideBearing: 43,
            advanceWidth: 478,
        },
        _: {
            xMin: 29,
            xMax: 563,
            yMin: -110,
            yMax: -1,
            ha: 109,
            leftSideBearing: 29,
            advanceWidth: 598,
        },
        '`': {
            xMin: 54,
            xMax: 321,
            yMin: 540,
            yMax: 747,
            ha: 207,
            leftSideBearing: 54,
            advanceWidth: 368,
        },
        a: {
            xMin: 20,
            xMax: 447,
            yMin: -17,
            yMax: 495,
            ha: 512,
            leftSideBearing: 20,
            advanceWidth: 494,
        },
        b: {
            xMin: 37,
            xMax: 466,
            yMin: -27,
            yMax: 770,
            ha: 797,
            leftSideBearing: 37,
            advanceWidth: 510,
        },
        c: {
            xMin: 35,
            xMax: 456,
            yMin: -9,
            yMax: 507,
            ha: 516,
            leftSideBearing: 35,
            advanceWidth: 460,
        },
        d: {
            xMin: 45,
            xMax: 520,
            yMin: -15,
            yMax: 764,
            ha: 779,
            leftSideBearing: 45,
            advanceWidth: 560,
        },
        e: {
            xMin: 33,
            xMax: 370,
            yMin: -5,
            yMax: 501,
            ha: 506,
            leftSideBearing: 33,
            advanceWidth: 397,
        },
        f: {
            xMin: 35,
            xMax: 411,
            yMin: -13,
            yMax: 695,
            ha: 708,
            leftSideBearing: 35,
            advanceWidth: 453,
        },
        g: {
            xMin: 33,
            xMax: 551,
            yMin: -257,
            yMax: 505,
            ha: 762,
            leftSideBearing: 33,
            advanceWidth: 611,
        },
        h: {
            xMin: 32,
            xMax: 458,
            yMin: -29,
            yMax: 743,
            ha: 772,
            leftSideBearing: 32,
            advanceWidth: 491,
        },
        i: {
            xMin: 45,
            xMax: 167,
            yMin: -13,
            yMax: 631,
            ha: 644,
            leftSideBearing: 45,
            advanceWidth: 220,
        },
        j: {
            xMin: -127,
            xMax: 261,
            yMin: -231,
            yMax: 601,
            ha: 832,
            leftSideBearing: -127,
            advanceWidth: 308,
        },
        k: {
            xMin: 39,
            xMax: 443,
            yMin: -3,
            yMax: 700,
            ha: 703,
            leftSideBearing: 39,
            advanceWidth: 497,
        },
        l: {
            xMin: 58,
            xMax: 168,
            yMin: -8,
            yMax: 686,
            ha: 694,
            leftSideBearing: 58,
            advanceWidth: 227,
        },
        m: {
            xMin: 39,
            xMax: 688,
            yMin: -14,
            yMax: 501,
            ha: 515,
            leftSideBearing: 39,
            advanceWidth: 718,
        },
        n: {
            xMin: 45,
            xMax: 491,
            yMin: -32,
            yMax: 512,
            ha: 544,
            leftSideBearing: 45,
            advanceWidth: 541,
        },
        o: {
            xMin: 41,
            xMax: 424,
            yMin: -12,
            yMax: 493,
            ha: 505,
            leftSideBearing: 41,
            advanceWidth: 447,
        },
        p: {
            xMin: 25,
            xMax: 529,
            yMin: -260,
            yMax: 500,
            ha: 760,
            leftSideBearing: 25,
            advanceWidth: 573,
        },
        q: {
            xMin: 53,
            xMax: 603,
            yMin: -235,
            yMax: 514,
            ha: 749,
            leftSideBearing: 53,
            advanceWidth: 623,
        },
        r: {
            xMin: 32,
            xMax: 407,
            yMin: -7,
            yMax: 492,
            ha: 499,
            leftSideBearing: 32,
            advanceWidth: 460,
        },
        s: {
            xMin: 49,
            xMax: 416,
            yMin: -12,
            yMax: 519,
            ha: 531,
            leftSideBearing: 49,
            advanceWidth: 460,
        },
        t: {
            xMin: 32,
            xMax: 442,
            yMin: -5,
            yMax: 684,
            ha: 689,
            leftSideBearing: 32,
            advanceWidth: 469,
        },
        u: {
            xMin: 41,
            xMax: 487,
            yMin: -5,
            yMax: 507,
            ha: 512,
            leftSideBearing: 41,
            advanceWidth: 510,
        },
        v: {
            xMin: 16,
            xMax: 441,
            yMin: -20,
            yMax: 542,
            ha: 562,
            leftSideBearing: 16,
            advanceWidth: 456,
        },
        w: {
            xMin: 39,
            xMax: 639,
            yMin: -22,
            yMax: 505,
            ha: 527,
            leftSideBearing: 39,
            advanceWidth: 661,
        },
        x: {
            xMin: 15,
            xMax: 505,
            yMin: -39,
            yMax: 539,
            ha: 578,
            leftSideBearing: 15,
            advanceWidth: 541,
        },
        y: {
            xMin: -98,
            xMax: 501,
            yMin: -242,
            yMax: 511,
            ha: 753,
            leftSideBearing: -98,
            advanceWidth: 548,
        },
        z: {
            xMin: 27,
            xMax: 479,
            yMin: -3,
            yMax: 494,
            ha: 497,
            leftSideBearing: 27,
            advanceWidth: 494,
        },
        '{': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308,
        },
        '|': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308,
        },
        '}': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308,
        },
        '~': {
            xMin: 0,
            xMax: 0,
            yMin: 0,
            yMax: 0,
            ha: 0,
            leftSideBearing: 0,
            advanceWidth: 308,
        },
    },
    fontFamily: 'PetalumaScript',
    resolution: 1000,
    generatedOn: '2020-06-14T18:33:25.407Z',
};
